import React, { useMemo } from 'react';

const ActiveBetRow = React.memo(({ bet, currentUsername, maskName }) => {
  // Compute className once per bet update
  const rowClassName = useMemo(() => {
    if (bet.cashout_multiplier) return 'table-row-green';
    if (bet.the_username === currentUsername) return 'table-row-you-tag';
    return 'table-row-blue';
  }, [bet.cashout_multiplier, bet.the_username, currentUsername]);

  const multiplierClassName = useMemo(() =>
    bet.cashout_multiplier ? 'multipler-value' : 'gray-text',
    [bet.cashout_multiplier]
  );

  const profitClassName = useMemo(() =>
    bet.profit ? 'green-text' : 'gray-text',
    [bet.profit]
  );

  const maskedUsername = useMemo(() =>
    maskName(bet.the_username),
    [bet.the_username, maskName]
  );

  const isCurrentUser = bet.the_username === currentUsername;

  return (
    <div className="container-crash-history">
      <ul className="active-bet-table">
        <div className="row-bet-wrapper">
          <li className={`grid grid-cols-7 ${rowClassName}`}>
            <div className="col-span-2 col col-1 flex items-center gap-2 select-none">
              <img
                src={`/${bet.the_avatar}`}
                className="rounded-full profile-img"
                alt={bet.the_username}
              />
              <span className="flex items-center gap-1 select-none">
                {maskedUsername}
                {isCurrentUser && <img src="/Tag YOU.svg" alt="You" />}
              </span>
            </div>
            <div className="col-span-2 col col-2 flex items-center justify-center select-none">
              {bet.bet_amount}
            </div>
            <div className={`col col-3 flex items-center justify-center select-none ${multiplierClassName}`}>
              {bet.cashout_multiplier ? bet.cashout_multiplier : "--"}
            </div>
            <div className={`col-span-2 col col-4 flex items-center justify-end text-white pr-2 select-none ${profitClassName}`}>
              {bet.profit ? bet.profit.toFixed(2) : "--"}
            </div>
          </li>
        </div>
      </ul>
    </div>
  );
}, (prevProps, nextProps) => {
  // Custom comparison - only re-render if bet data actually changed
  return (
    prevProps.bet.cashout_multiplier === nextProps.bet.cashout_multiplier &&
    prevProps.bet.profit === nextProps.bet.profit &&
    prevProps.bet.the_username === nextProps.bet.the_username &&
    prevProps.bet.bet_amount === nextProps.bet.bet_amount &&
    prevProps.bet.the_avatar === nextProps.bet.the_avatar &&
    prevProps.currentUsername === nextProps.currentUsername
  );
});

ActiveBetRow.displayName = 'ActiveBetRow';

export default ActiveBetRow;
